module.exports = __webpack_public_path__ + "img/map.8af54eb6.png";